import resultComps from '@/views/entryManage/index.js'

function creatEntry () {
  return Object.keys(resultComps).map(key => {
    return {
      path: '/' + key,
      name: 'entry' + key,
      meta: {
        title: '门户',
        structure: 'FULL', //全页面模式
        code: 'entry' + key,
        authorized: true,
      },
      component: resolve => require([`@/views/entryManage/${key}`], resolve)
    }
  })
}
export default creatEntry()